import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function ReviewSlider() {
  const [beliefs, setBeliefs] = useState([]);

  const testimonials = [
    {
      id: 1,
      name: "Priya Sharma",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
      description: "🌈 Color Kingdon has transformed our family evenings! My 5-year-old daughter absolutely loves her animal-themed colouring book. The thick paper quality means no bleed-through even with her heavy crayon strokes. The designs are so engaging and educational - she's learning shapes, colors, and animals while having fun. Perfect for little hands and big imaginations. Highly recommend for parents looking for quality screen-free activities!"
    },
    {
      id: 2,
      name: "Rahul Patel",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
      description: "🎨 As an adult who needed stress relief, these mandala books are perfection! The intricate patterns are therapeutic and beautifully hand-drawn. Each page feels like a mini vacation for the mind. The paper quality is premium - markers, pencils, and gel pens all work beautifully without smudging. Color Kingdon truly understands what modern adults need for relaxation. My focus and creativity have improved tremendously!"
    },
    {
      id: 3,
      name: "Anita Desai",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
      description: "🧒 My kindergarten students are obsessed with these kids' colouring books! The designs teach numbers, letters, and animals through fun illustrations. Parents love that they're educational yet entertaining. We've ordered multiple copies for classroom activities and return gifts. The vibrant covers attract kids immediately, and the sturdy binding withstands rough handling. Color Kingdon has become our go-to for educational art supplies!"
    },
    {
      id: 4,
      name: "Vikram Singh",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
      description: "⭐ Perfect birthday gift for my 8-year-old niece! The fantasy theme book with unicorns and fairies was a huge hit. She spent hours colouring and even started creating her own stories from the pictures. The quality exceeded expectations - thick pages, beautiful designs, and age-appropriate complexity. Color Kingdon books make thoughtful, screen-free gifts that keep kids engaged and happy for days!"
    },
    {
      id: 5,
      name: "Sneha Gupta",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
      description: "🌿 The nature collection is breathtaking! As a gardening enthusiast, I love colouring realistic flowers, leaves, and landscapes. It's incredibly relaxing after long workdays. The attention to botanical detail makes each page educational too. Friends noticed my improved focus and asked for recommendations. Color Kingdon's advanced books are perfect for adults seeking both beauty and stress relief through art therapy."
    },
    {
      id: 6,
      name: "Amit Kumar",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face",
      description: "🎉 Festival-themed books made Diwali extra special! My family enjoyed colouring rangoli patterns, diyas, and traditional motifs together. Great quality for group activities. The designs captured authentic Indian festival essence perfectly. We've bookmarked Color Kingdon for all upcoming celebrations. Excellent value for money and wonderful shared family experience!"
    },
    {
      id: 7,
      name: "Meera Joshi",
      image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=100&h=100&fit=crop&crop=face",
      description: "✨ Corporate gifting success! Ordered 50 kids' colouring books as return gifts for our company event. Everyone loved the quality and thoughtful packaging. Clients with children especially appreciated the premium feel. Color Kingdon helped us make a memorable impression. Professional service and beautiful products - will definitely reorder for future events!"
    },
    {
      id: 8,
      name: "Rohan Mehra",
      image: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=100&h=100&fit=crop&crop=face",
      description: "🐯 Animal lovers paradise! My son learned so much about wildlife while colouring these realistic animal portraits. From tigers to dolphins, each page teaches facts through beautiful illustrations. The books double as educational tools and art therapy. Color Kingdon blends learning and creativity seamlessly. Outstanding for curious young minds!"
    },
    {
      id: 9,
      name: "Divya Rao",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
      description: "🛍️ Fast delivery and excellent packaging! My advanced colouring book arrived in perfect condition. The pages lay completely flat, making colouring easy. Been using it daily for mindfulness practice. Color Kingdon's commitment to quality shows in every detail. My best purchase this year!"
    },
    {
      id: 10,
      name: "Karan Malhotra",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
      description: "💯 100% satisfied customer! Been buying these books monthly for my art therapy sessions with children. The variety of themes keeps everyone engaged. Teachers and therapists across my network now recommend Color Kingdon. Reliable quality, inspiring designs, and meaningful impact on young artists' development!"
    }
  ];

  useEffect(() => {
    // Simulate loading delay for realistic UX
    const timer = setTimeout(() => {
      setBeliefs(testimonials);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="row review_slider px-sm-5 overflow-hidden">
      <div className="row px-sm-5">
        <div className="text-center about-title2">
          <h2 className="title">Our Customers Say</h2>
        </div>
      </div>

      <Slider {...settings} className="mt-4">
        {beliefs.length > 0 ? (
          beliefs.map((item) => (
            <div key={item.id} className="custom_slider text-center">
              <div className="review_detail m-3">
                <img
                  src={item.image}
                  alt={item.name}
                  className="review-img d-inline-block"
                  style={{ width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover' }}
                />
                <p dangerouslySetInnerHTML={{ __html: item.description }} />
                <div className="name_of_reviewer fw-bold text-primary">{item.name}</div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center p-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading reviews...</p>
          </div>
        )}
      </Slider>
    </section>
  );
}

export default ReviewSlider;